import { Stack, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import React, { useMemo } from "react";
import { scrollbarStyle } from "../../../shared/dashboard";
import { EmailBody } from "../../../types/files";
import { decode } from "quoted-printable";

const useStyles = makeStyles((theme) => ({
    summaryContainer: {
        width: '100%',
        height: 'auto',
        background: '#fff',
        border: `1px solid ${theme.colors.neutral['300']}`,
        boxShadow: '0px 4px 10px -1px rgba(16, 24, 40, 0.06)',
        borderRadius: 16,
        padding: 16,
        breakInside: 'avoid',
        transition: '0.05s ease-in-out',
    },
    emailBlock: {
        width: '100%',
        height: 'auto',
        minHeight: '67px',
        maxHeight: '224px',
        overflowY: 'auto',
        ...scrollbarStyle,
    },
    bodyText: {
        fontFamily: 'Inter',
        fontSize: '0.85rem',
        color: theme.colors.neutral['600'],
        textAlign: 'left',
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word',
    },
}));

const EmailContent: React.FC<{ content: EmailBody }> = ({ content }) => {
    const classes = useStyles();

    const bodyText = useMemo(() => decode(content?.content || 'No content.').toString()
        .replace(/\r\n/g, '\n').split('\n')
        .map(line => {
            const match = line.match(/^([>]+)\s?(.*)$/);
            if (!match) return line;

            const depth = match[1]?.length;
            const content = match[2]?.trim();
            if (!content) return '';
            return ' '.repeat(depth) + content;
        }).join('\n')
    , [content?.content]);

    return (<>
        <Stack direction="row" className={classes.summaryContainer}
            alignItems="flex-start" justifyContent="space-between">
            <Stack className={classes.emailBlock}>
                <Typography className={classes.bodyText}>
                    {bodyText}
                </Typography>
            </Stack>
        </Stack>
    </>);
}

export default EmailContent;
